import { render, staticRenderFns } from "./ProductWorkflows.vue?vue&type=template&id=6193076a"
import script from "./ProductWorkflows.vue?vue&type=script&lang=js"
export * from "./ProductWorkflows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports